<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png" width="200" height="200">
    <h1> PolterHeist </h1>
    <p> Join the discord: </p> 
    <a href="https://discord.gg/zXme6mG"> https://discord.gg/zXme6mG </a>
    <h2> Download prototype builds: </h2>
    <p> Make sure to pick the most recent date! </p>
    <iframe src="https://drive.google.com/embeddedfolderview?id=1jDiJdvC6GLqkPCryPwyCcQtJsvCSjPJf#list" width="600" height="500" frameborder="0"></iframe>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
}
</script>
